import React, { useState } from 'react'
import moment from 'moment'

import { useFormik } from 'formik'
import { useHistory } from 'react-router'
import DateRange from '@material-ui/icons/DateRange'
import { GenderNew } from 'common/enum/gender'
import { toast } from 'react-toastify'
import { useServices } from 'presentation/hooks/use-services'
// import { useStores } from 'presentation/hooks/use-stores'
import {
  MaritalStatus,
  maritalStatus
} from 'presentation/utils/default-marital-status'
import {
  cpfMask,
  dateMask,
  landlineMaskWithParenthesis,
  phoneMask
} from 'presentation/utils/masks'
import { isValidDate } from 'presentation/utils/validators/is-valid-data'
import { isPatientRN } from 'presentation/utils/validators/is-patient-rn'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { ContainerNew } from 'presentation/shared/components/ContainerNew'
import Calendar from 'presentation/shared/components/Calendar'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import ValidationSchema from './validationSchema'
import { ReactComponent as SearchIcon } from 'presentation/assets/icons/search.svg'
import * as S from './styles'

type AddPatientDefaultValues = {
  // hospital_id: number
  name: string
  email: string
  phone: string
  landlinePhone?: string
  birthday: string
  cpf: string
  gender: GenderNew
  marital_status: MaritalStatus
}

const AddPatientDefault = WithLoading(({ setIsLoading }: WithLoadingProps) => {
  // const { state } = useLocation<{
  //   hospital_id: number
  //   isEditing?: boolean
  // }>()
  const history = useHistory()
  const patientServices = useServices().patient
  const [showCalendar, setShowCalendar] = useState<boolean>(false)
  // const patientContext = surgicalOrderContext.getPatient()
  const patientService = useServices().patient
  const [messagePatientNotFound, setMessagePatientNotFound] =
    useState<string>('')

  const toggleCalendar = () => {
    setShowCalendar(showCalendar !== true)
  }

  const changeDate = (date: any) => {
    formik.resetForm()
    const momentDate = moment(date)
    if (momentDate.isValid()) {
      formik.setFieldValue('birthday', momentDate.format('DD/MM/YYYY'))
      toggleCalendar()
    } else {
      formik.setFieldValue('birthday', '')
    }
  }

  // const handleBackButton = () => history.goBack()

  const isNotFutureDate = (date: string) =>
    moment().diff(moment(date, 'DD/MM/YYYY'), 'seconds') >= 0

  const handleSearchPatientByCPF = async () => {
    if (!isPatientRN(formik.values.birthday) || formik.errors.cpf) return

    try {
      setIsLoading(true)

      const formatedCPF = formik.values.cpf?.replace(/\D+/g, '')
      const response = await patientService.getPatientByCpfOrName({
        cpf: formatedCPF
      })

      if (response[0] && response[0]?.name) {
        formik.setFieldValue('name', response[0]?.name)
        formik.setFieldValue('email', response[0]?.user?.email)
        formik.setFieldValue('phone', response[0]?.user?.phone)
      } else {
        setMessagePatientNotFound(
          'Paciente não encontrado. Cadastre novo paciente.'
        )
        return
      }
    } catch (error: any) {
      toast.error(error?.message)
    } finally {
      setIsLoading(false)
    }
  }

  const onPressEnterKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 13) {
      handleSearchPatientByCPF()
    }
  }

  const handleCPFInputChange = () => {
    // Remove error message
    setMessagePatientNotFound('')
    // Reset form fields
    formik.setFieldValue('name', '')
    formik.setFieldValue('email', '')
    formik.setFieldValue('phone', '')
  }

  const formik = useFormik({
    initialValues: {} as AddPatientDefaultValues,
    validationSchema: ValidationSchema,
    validateOnMount: true,
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const {
        name,
        email,
        phone,
        landlinePhone,
        birthday,
        cpf,
        gender,
        marital_status
      } = values

      const formatedBirthdayDate = moment(birthday, 'DD/MM/YYYY').toISOString()
      const formatedPhone = phone?.replace(/\D/g, '')
      const formatedLandlinePhone = landlinePhone?.replace(/\D/g, '')
      const formatedCPF = cpf?.replace(/\D+/g, '')

      const patientPayload = {
        hospital_id: Number(1), //TEMP MOCK!!! Analisar a necessidade desse campo no backend
        gender: gender,
        name,
        marital_status,
        birthday: formatedBirthdayDate,
        cpf: formatedCPF,
        phone: formatedPhone,
        landline: formatedLandlinePhone,
        email
      }

      const patientRNPayload = {
        hospital_id: Number(1), //TEMP MOCK!!! Analisar a necessidade desse campo no backend
        gender: gender,
        name: `RN de ${name}`,
        marital_status: MaritalStatus.SINGLE,
        birthday: formatedBirthdayDate,
        cpf: formatedCPF,
        phone: formatedPhone,
        landline: formatedLandlinePhone,
        email
      }

      const payload = isPatientRN(birthday) ? patientRNPayload : patientPayload

      try {
        setIsLoading(true)
        await patientServices.createNewPatient(payload)
        formik.resetForm()
        toast.success('Paciente cadastrado com sucesso!')
        history.goBack()
      } catch (err: any) {
        console.error(`Novo paciente: ${err?.message}`)
        formik.setFieldError('cpf', err?.message)
      } finally {
        setIsLoading(false)
      }
    }
  })

  return (
    <ContainerNew
      title="Cadastrar novo paciente"
      titleColor="neutral800"
      titleSize="large"
      titleWeight="bold"
      // buttonsHasBoxShadow={!state?.isEditing}
      primaryButton={
        <ButtonNew
          fullWidth
          size="large"
          onClick={formik.submitForm}
          disabled={!formik.isValid || formik.isSubmitting}
        >
          {/* {state?.isEditing ? 'Novo paciente' : 'Próximo'} */}
          Cadastrar paciente
        </ButtonNew>
      }
    >
      <S.FormWrapper onSubmit={formik.handleSubmit}>
        <div>
          <TextFieldNew
            label="Data de nascimento "
            labelOverlapping
            labelSize="xxsmall"
            placeholder="Digite a data de nascimento"
            name="birthday"
            id="birthday"
            mask={dateMask}
            icon={<DateRange />}
            iconPosition="insideRight"
            iconIsButton
            // iconBgColor="transparent"
            // iconColor="neutral200"
            onIconClick={() => toggleCalendar()}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.birthday}
            required
            requiredColor="neutral800"
            error={formik.touched.birthday ? formik.errors.birthday : undefined}
          />
          {showCalendar && (
            <Calendar
              value={
                isValidDate(formik.values.birthday)
                  ? moment(formik.values.birthday, 'DD/MM/YYYY').toDate()
                  : undefined
              }
              onDateChange={(date) => changeDate(date)}
              maxDate={moment().toDate()}
            />
          )}

          {isValidDate(formik.values.birthday) &&
            isPatientRN(formik.values.birthday) && (
              <SupportTextNew
                size="xsmall"
                color="neutral700"
                style={{ marginTop: '8px', lineHeight: '1.3' }}
              >
                Pacientes com até 30 dias de nascimento são considerados
                recém-nascidos. Neste caso, o cadastro é feito no nome da mãe.
              </SupportTextNew>
            )}
        </div>

        {/* Show when birthday is filled */}
        {isValidDate(formik.values.birthday) &&
          isNotFutureDate(formik.values.birthday) && (
            <>
              <div>
                <TextFieldNew
                  label={`CPF ${
                    isPatientRN(formik.values.birthday)
                      ? 'da mãe '
                      : 'do paciente '
                  }`}
                  labelOverlapping
                  labelSize="xxsmall"
                  placeholder={`Digite o CPF ${
                    isPatientRN(formik.values.birthday)
                      ? 'da mãe'
                      : 'do paciente'
                  }`}
                  name="cpf"
                  id="cpf"
                  mask={cpfMask}
                  onChange={formik.handleChange}
                  onInputChange={handleCPFInputChange}
                  error={
                    (formik.touched.cpf && formik.errors.cpf) ||
                    messagePatientNotFound
                  }
                  onBlur={formik.handleBlur}
                  value={formik.values.cpf || ''}
                  icon={
                    isPatientRN(formik.values.birthday) &&
                    !formik.errors.cpf && <SearchIcon />
                  }
                  iconIsButton={true}
                  onIconClick={handleSearchPatientByCPF}
                  onKeyDown={onPressEnterKey}
                  required
                  requiredColor="neutral800"
                />
              </div>

              {isPatientRN(formik.values.birthday) ? (
                <div>
                  <S.RNInputWrapper>
                    <TextFieldNew
                      placeholder="RN"
                      value="RN"
                      disabled
                      readOnly
                    />
                    <TextFieldNew
                      placeholder="Informe o CPF da mãe"
                      label="Nome da mãe"
                      labelOverlapping
                      labelSize="xxsmall"
                      name="name"
                      id="name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name || ''}
                      error={formik.touched.name && formik.errors.name}
                      disabled={isPatientRN(formik.values.birthday)}
                      readOnly={isPatientRN(formik.values.birthday)}
                      required
                      requiredColor="neutral800"
                    />
                  </S.RNInputWrapper>
                </div>
              ) : (
                <div>
                  <TextFieldNew
                    label="Nome do paciente "
                    labelOverlapping
                    labelSize="xxsmall"
                    placeholder="Digite o nome do paciente"
                    name="name"
                    id="name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name || ''}
                    error={formik.touched.name && formik.errors.name}
                    required
                    requiredColor="neutral800"
                  />
                </div>
              )}

              <div>
                <SelectFieldNew
                  label="Sexo "
                  labelOverlapping
                  labelSize="xxsmall"
                  placeholder="Selecione o sexo"
                  name="gender"
                  id="gender"
                  value={formik.values.gender || ''}
                  items={[
                    {
                      label: 'Masculino',
                      value: GenderNew.MALE
                    },
                    {
                      label: 'Feminino',
                      value: GenderNew.FEMALE
                    }
                  ]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.gender && formik.errors.gender}
                  required
                  requiredColor="neutral800"
                />
              </div>

              {/* {!isPatientRN(formik.values.birthday) && (
                <div>
                  <SelectFieldNew
                    label="Estado civil "
                    labelOverlapping
                    labelSize="xxsmall"
                    placeholder="Selecione o estado civil"
                    name="marital_status"
                    id="marital_status"
                    value={formik.values.marital_status || ''}
                    items={maritalStatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.marital_status &&
                      formik.errors.marital_status
                    }
                    required
                    requiredColor="neutral800"
                  />
                </div>
              )} */}

              <div>
                <SelectFieldNew
                  label="Estado civil "
                  labelOverlapping
                  labelSize="xxsmall"
                  placeholder="Selecione o estado civil"
                  name="marital_status"
                  id="marital_status"
                  value={formik.values.marital_status || ''}
                  items={maritalStatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.marital_status &&
                    formik.errors.marital_status
                  }
                  required
                  requiredColor="neutral800"
                />
              </div>

              <div>
                <TextFieldNew
                  label="Celular "
                  labelOverlapping
                  labelSize="xxsmall"
                  placeholder="Digite o celular"
                  name="phone"
                  id="phone"
                  value={formik.values.phone || ''}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  mask={phoneMask}
                  error={formik.touched.phone && formik.errors.phone}
                  required
                  requiredColor="neutral800"
                />
              </div>

              <div>
                <TextFieldNew
                  labelOverlapping
                  labelSize="xxsmall"
                  labelWeight="semiBold"
                  labelColor="neutral700"
                  label="Telefone fixo"
                  id="landlinePhone"
                  name="landlinePhone"
                  placeholder="Digite o telefone fixo"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  mask={landlineMaskWithParenthesis}
                  value={formik.values.landlinePhone || ''}
                  error={
                    formik.touched.landlinePhone && formik.errors.landlinePhone
                  }
                />
              </div>

              <div>
                <TextFieldNew
                  label="E-mail "
                  labelOverlapping
                  labelSize="xxsmall"
                  placeholder="Digite o e-mail"
                  name="email"
                  id="email"
                  value={formik.values.email || ''}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && formik.errors.email}
                  required
                  requiredColor="neutral800"
                />
              </div>
            </>
          )}
      </S.FormWrapper>
    </ContainerNew>
  )
})

export default AddPatientDefault
